import { siteConfig, CONFIDENTIALITY_NOTICE } from "../config";
import { useView } from "../context/ViewContext";
import { useSafeLink } from "./common";
import { ShieldCheck } from "lucide-react";

export default function Footer() {
  const { goTo } = useView();
  const safeLink = useSafeLink();
  return (
    <footer className="border-t border-cyan/15 bg-navy2/60 print:hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="panel p-5 border-warn/30" data-testid="confidentiality-notice">
          <div className="flex items-start gap-3">
            <ShieldCheck className="w-5 h-5 text-warn shrink-0 mt-0.5" aria-hidden="true" />
            <div>
              <p className="font-sans text-sm font-semibold text-paper">Confidentiality &amp; Data Notice</p>
              <p className="text-xs text-steel mt-2 leading-relaxed max-w-4xl">{CONFIDENTIALITY_NOTICE}</p>
            </div>
          </div>
        </div>
        <div className="mt-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <p className="font-sans text-paper font-semibold">{siteConfig.name}</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-cyan/70 mt-1">
              Manufacturing × Product Quality × Data × Automation × QMS
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Footer">
            {[
              ["Projects", "projects"],
              ["RCA Lab", "rca-lab"],
              ["Continuous Improvement", "continuous-improvement"],
              ["Analytics Lab", "analytics-lab"],
              ["IoT", "iot"],
              ["Contact", "contact"],
            ].map(([label, id]) => (
              <button key={id} onClick={() => goTo(id)} className="text-xs text-pale/60 hover:text-cyan transition-colors" data-testid={`footer-link-${id}`}>
                {label}
              </button>
            ))}
            <button onClick={() => safeLink(siteConfig.resumeUrl, "Resume")} className="text-xs text-pale/60 hover:text-cyan transition-colors" data-testid="footer-resume-link">
              Resume
            </button>
            <a href="/recruiter-one-pager" className="text-xs text-pale/60 hover:text-cyan transition-colors" data-testid="footer-onepager-link">
              Recruiter One-Pager
            </a>
            <a href="/analytics-lab/pattern-hunt" className="text-xs text-pale/60 hover:text-cyan transition-colors" data-testid="footer-pattern-hunt-link">
              Pattern Hunt
            </a>
          </nav>
        </div>
        <p className="mt-8 font-mono text-[10px] text-steel/70">
          © {new Date().getFullYear()} {siteConfig.name}. Synthetic demonstration data only. Built for static hosting.
        </p>
      </div>
    </footer>
  );
}
